export default __webpack_public_path__ + "static/media/banner-image-square-1.46826990.jpg";